
import React from "react";

export const ProgressBar = ({ value, label, showPercentage = true }) => {
  const percentage = Math.min(Math.max(value || 0, 0), 100);
  
  return (
    <div className="w-full space-y-1.5">
      {(label || showPercentage) && (
        <div className="flex justify-between items-center text-[11px] font-medium text-slate-500">
          {label && <span>{label}</span>}
          {showPercentage && <span className="font-bold" style={{ color: '#7ba2bf' }}>{Math.round(percentage)}%</span>}
        </div>
      )}
      <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden border border-slate-50">
        <div 
          className="h-full transition-all duration-500 ease-out rounded-full shadow-[0_0_8px_rgba(123,162,191,0.3)]"
          style={{ width: `${percentage}%`, backgroundColor: '#7ba2bf' }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
